<template>
    <div>
        <div class="container remove-padding-margin" id="detailsetprod">
            <div class="fixed-top bg-white">
                <div class="nav-center pageDefault">
                    <div class="row set-row d-flex">
                        <div class="remove-padding navbar-icon-left" @click="back">
                            <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                        </div>
                        <div class="text-center remove-padding flex-1 font-weight-600">
                            Detail Workshop
                        </div>
                        <div class="navbar-icon-right remove-padding">

                        </div>
                    </div>
                </div>
            </div>
            <main class="">
                <div class="flex-100">
                    <div class="flex-1">
                        <div class="mar-top-60"></div>
                        <div class="row remove-margin text-detailO" :data-toggle="validateAccess('workshopProductionProces.update') && 'modal'" data-target="#modalEnamesetprod">
                            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                <div class="font-14  mar-top-5 mar-bot-0 color-8080">
                                    Nama Workshop
                                </div>
                                <div class="nomore">
                                    {{workshop.nama}}
                                </div>
                            </div>
                            <div v-if="validateAccess('workshopProductionProces.update')" class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
                                <span><i class="far fa-edit color-206CF"></i></span>
                            </div>
                        </div>
                        <div class="row remove-margin text-detailO" :data-toggle="validateAccess('workshopProductionProces.update') && 'modal'" data-target="#modalEtelpsetprod">
                            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                <div class="font-14  mar-top-5 mar-bot-0 color-8080">
                                    Nomor Telpon Workshop
                                </div>
                                <div>
                                    {{workshop.telp}}
                                </div>
                            </div>
                            <div v-if="validateAccess('workshopProductionProces.update')" class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right">
                                <span><i class="far fa-edit color-206CF"></i></span>
                            </div>
                        </div>
                        <div class="row remove-margin text-detailO" :data-toggle="validateAccess('workshopProductionProces.update') && 'modal'" data-target="#modalEkotasetprod">
                            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                <h6 class="font-14  mar-top-5 mar-bot-0 color-8080">
                                    Kota
                                </h6>
                                <h6>
                                    {{workshop.kota}}
                                </h6>
                            </div>
                            <div v-if="validateAccess('workshopProductionProces.update')" class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right"  >
                                <span><i class="far fa-edit color-206CF"></i></span>
                            </div>
                        </div>
                        <div class="row remove-margin text-detailO" :data-toggle="validateAccess('workshopProductionProces.update') && 'modal'" data-target="#modalEaddresssetprod">
                            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">
                                <h6 class="font-14  mar-top-5 mar-bot-0 color-8080">
                                    Alamat Lengkap
                                </h6>
                                <h6>
                                    {{workshop.alamat}}
                                </h6>
                            </div>
                            <div v-if="validateAccess('workshopProductionProces.update')" class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin text-right" >
                                <span><i class="far fa-edit color-206CF"></i></span>
                            </div>
                        </div>
                        <div class="pembatas remove-margin"></div>
                        <div class="row remove-margin text-detailO" @click="settahapandetailworkshop">
                            <div class="col-sm-6 col-md-6 col-lg-6 col-6 remove-padding-margin">
                                <h6 class="font-14 remove-margin font-colorcheck text-promo">
                                    Proses Produksi
                                </h6>
                                <h6 class="font-14 remove-margin color-80808">
                                    {{isidatatahapan}} Tahapan Workshop
                                </h6>
                            </div>
                            <div class="col-sm-6 col-md-6 col-lg-6 col-6 text-right remove-padding">
                                <span><img class="mar-top-5" src="../../assets/icons/chevron-right1.svg" alt=""></span>
                            </div>

                        </div>
                        <div class="pembatas remove-margin"></div>
                        <div class="row remove-margin text-detailO" data-toggle="modal" data-target="#modalDelete" v-if="validateAccess('workshop.hide')">
                            <div class="col-sm-2 col-md-2 col-lg-2 col-2 remove-padding-margin">
                                <img src="../../assets/icons/trash-2.svg" alt="">
                            </div>
                            <div class="col-sm-10 col-md-10 col-lg-10 col-10 remove-padding-margin">Sembunyikan Workshop</div>
                        </div>
                        <div class="modal fade" id="modalDelete" role="dialog">
                            <div class="modal-dialog modal-lg  bani-modal">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <div class="nav-btn kiri"></div>
                                        <h5 class="navbar-title text-center">Sembunyikan Workshop?</h5>
                                        <div class="nav-btn kanan tutup">
                                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                        </div>
                                    </div>
                                    <div class="modal-body">
                                        <p class="remove-margin">Workshop hanya akan disembunyikan,semua data keuangan akan tetap
                                            tersimpan & ditampilkan.</p>
                                    </div>
                                    <div class="modal-footer remove-margin">
                                        <p class="text-left">Apa anda yakin ingin menyembunyikan workshop {{ workshop.nama }}? </p>
                                        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                                                @click="delworkshop">Ya, Sembunyikan
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade" id="modalEnamesetprod" role="dialog">
                            <div class="modal-dialog modal-lg  bani-modal">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <div class="nav-btn kiri"></div>
                                        <h5 class="navbar-title text-center">Ubah Nama Workshop</h5>
                                        <div class="nav-btn kanan tutup">
                                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                        </div>
                                    </div>
                                    <div class="modal-body">
                                        <form action="">
                                            <div class="form-group">
                                                <label class="remove-margin font-14 color-8080" for="namaDPOworkshop">Nama
                                                    Workshop </label>
                                                <input type="text" class="form-control inputs" id="namaDPOworkshop"
                                                       v-model="namaworkshop" @keyup="inputnama">
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" id="BtnDetailNamaWorkshop" disabled
                                                @click="updateName">Simpan
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade" id="modalEtelpsetprod" role="dialog">
                            <div class="modal-dialog modal-lg  bani-modal">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <div class="nav-btn kiri"></div>
                                        <h5 class="navbar-title text-center">Ubah Telphone Workshop</h5>
                                        <div class="nav-btn kanan tutup">
                                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                        </div>
                                    </div>
                                    <div class="modal-body">
                                        <form action="">
                                            <div class="form-group">
                                                <label class="remove-margin font-14 color-8080" for="telpworkshop">Telphone
                                                    Workshop</label>
                                                <div class="input-group remove-padding">
                                                    <vue-country-code
                                                        @onSelect="onSelect" :preferredCountries="['id', 'my', 'bn']">
                                                    </vue-country-code>
                                                    <input type="tel" class="form-control inputs" id="telpworkshop"
                                                           v-model="telpworkshop" v-on:keyup="nomorWaOnkeyup">
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" disabled id="BtnDetailTelpWorkshop"
                                                @click="updateTelp">Simpan
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade" id="modalEkotasetprod" role="dialog" aria-hidden="true">
                            <div class="modal-dialog modal-lg  bani-modal">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <div class="nav-btn kiri"></div>
                                        <h5 class="navbar-title text-center">Ubah Kota Workshop</h5>
                                        <div class="nav-btn kanan tutup">
                                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                        </div>
                                    </div>
                                    <div class="modal-body set-modal-body">
                                        <div class="mod">
                                            <label for="select2" class="p-x-20 remove-margin font-14 color-8080">Kota workshop</label>
                                            <Select2   id="select2" class="p-x-20"
                                                       v-model="selectedkotaprodworkshop" :options="optionskota"
                                                       :settings="{ placeholder: 'Pilih Kota' }"
                                                       @change="myChangeEvent($event)" @select="mySelectEvent"/>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                                                @click="updateKota">Simpan
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade" id="modalEaddresssetprod" role="dialog">
                            <div class="modal-dialog modal-lg  bani-modal">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <div class="nav-btn kiri"></div>
                                        <h5 class="navbar-title text-center">Ubah Alamat Workshop</h5>
                                        <div class="nav-btn kanan tutup">
                                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                        </div>
                                    </div>
                                    <div class="modal-body">
                                        <form action="">
                                            <div class="form-group">
                                                <label class="remove-margin font-14 color-8080" for="addressDPOworkshop">Alamat Workshop</label>
                                                <input type="text" class="form-control inputs" id="addressDPOworkshop" v-model="alamatworkshop" @keyup="inputalamat">
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" disabled id="BtnDetailAlamatWorkshop"
                                                @click="updateAddress">Simpan
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
        <TahapanDetailSetProd v-bind:class="{hidesection:!istahapandetailsetprod}" v-bind:setidworkshoptahapandetail="idworkshop" v-on:gotodetailworkshop="gotodetailworkshopdata" ref="tahapandetailsetprod"/>
    </div>

</template>

<script>
    import Select2 from 'v-select2-component';
    import TahapanDetailSetProd from "./TahapanDetailSetProd";
    export default {
        name: "DetailWorkshopSetprod",
        components: {Select2,TahapanDetailSetProd},
        props:['setidworkshop'],
        data(){
            return{
                istahapandetailsetprod:false,
                idoutlet: '',
                workshop: {},
                selectedkotaprodworkshop: '1',
                optionskota: [],
                namakotaworkshop:'',
                namaworkshop:'',
                telpCode: '',
                telpworkshop:'',
                alamatworkshop:'',
                isClicked:true,
                idworkshop:this.setidworkshop,
                isidatatahapan:'',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
            }
        },
        mounted(){
            this.idworkshop = this.$route.params.idworkshop;
        },
        methods:{
            back(){
                this.$emit('gosetproduksi')
            },
            onSelect({name, iso2, dialCode}) {
              this.telpCode=dialCode;
            },
            gotodetailworkshopdata(idworkshop){
                this.istahapandetailsetprod=false;
                $('#detailsetprod').show();
                this.getdetailworkshopsetprod(idworkshop);
                this.getkotasetprod(idworkshop);
            },
            settahapandetailworkshop(idworkshop){
                this.istahapandetailsetprod = true;
                $('#detailsetprod').hide();
                this.$refs.tahapandetailsetprod.getChecklistdetailsetprod(idworkshop);
                this.$refs.tahapandetailsetprod.getTahapandetailsetprod(idworkshop);
            },

            inputnama(event){
                var name = event.target.value;
                var handle = name.replace(/[^0-9A-Za-z_.,' -]+/,'');
                this.namaworkshop = handle;
                this.checkvalidasinama()
            },

            checkvalidasinama(){
                var inputduplikat = this.namaworkshop;
                var lenPass = inputduplikat.length;
                if (lenPass >= 2) {
                    $('#BtnDetailNamaWorkshop').prop('disabled', false);
                } else {
                    $('#BtnDetailNamaWorkshop').prop('disabled', true);
                }
            },

            inputalamat(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z_.,()/' -]+/,'');
                this.alamatworkshop = number
                this.checkvalidasialamat()
            },

            checkvalidasialamat(){
                var inputduplikat = this.alamatworkshop;
                var lenPass = inputduplikat.length;
                if (lenPass >= 2) {
                    $('#BtnDetailAlamatWorkshop').prop('disabled', false);
                } else {
                    $('#BtnDetailAlamatWorkshop').prop('disabled', true);
                }
            },

            async getdetailworkshopsetprod() {
                $('#loadingPage').show()
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner')
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_workshop_meta?idworkshop=' + this.setidworkshop + '&idowner=' + idowner, this.requestHeaders)
                    if(response.data.status===true){
                        var tahapan = response.data.data.tahapan;
                        this.workshop = response.data.data.workshop;
                        this.isClicked = false;
                        this.namaworkshop=this.workshop.nama;
                        //this.telpworkshop=this.workshop.telp;
                        this.alamatworkshop=this.workshop.alamat;
                        this.selectedkotaprodworkshop=this.workshop.kota_id;
                        this.idworkshop=this.workshop.idworkshop;
                        this.isidatatahapan = tahapan.length;
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                        this.checkvalidasinama()
                        this.checkvalidasialamat()
                        this.nomorWaOnkeyup()
                    }

                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async getdetailworkshopsetproddata(idworkshop) {
                $('#loadingPage').show()
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner')
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_workshop_meta?idworkshop=' + idworkshop + '&idowner=' + idowner, this.requestHeaders)
                    if(response.data.status===true){
                        var tahapan = response.data.data.tahapan
                        this.workshop = response.data.data.workshop
                        this.isClicked = false;
                        this.namaworkshop=this.workshop.nama;
                        this.telpworkshop=this.workshop.telp;
                        this.alamatworkshop=this.workshop.alamat;
                        this.isidatatahapan = tahapan.length;
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                    }

                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async updateName(){
                $('#loadingPage').show()
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner')
                    const updatedata = new FormData()
                    updatedata.append('fieldValue', this.namaworkshop)
                    updatedata.append('fieldName', 'nama')
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_workshop?idowner='
                        + idowner + "&idworkshop=" + this.workshop.idworkshop, updatedata, this.requestHeaders);
                    if(response.data.status===true){
                        this.getdetailworkshopsetprod();
                        this.$toast.success(response.data.msg)
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                    }else{
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async updateTelp(){
                $('#loadingPage').show()
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner')
                    const updatedata = new FormData()
                    updatedata.append('fieldValue', this.telpCode+ this.telpworkshop)
                    updatedata.append('fieldName', 'telp')
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_workshop?idowner=' + idowner + "&idworkshop=" + this.workshop.idworkshop, updatedata, this.requestHeaders)
                    if(response.data.status===true){
                    	this.$toast.success(response.data.msg)
                        this.getdetailworkshopsetprod();
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                    }else{
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async updateAddress(){
                $('#loadingPage').show()
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner')
                    const updatedata = new FormData()
                    updatedata.append('fieldValue', this.alamatworkshop);
                    updatedata.append('fieldName', 'alamat')
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_workshop?idowner=' + idowner + "&idworkshop=" + this.workshop.idworkshop, updatedata, this.requestHeaders)
                    if(response.data.status===true){
                    	this.$toast.success(response.data.msg)
                        this.getdetailworkshopsetprod();
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                    }else{
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async updateKota(){
                $('#loadingPage').show()
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner')
                    const updatedata = new FormData()
                    updatedata.append('fieldValue', this.selectedkotaprodworkshop)
                    updatedata.append('fieldName', 'kota_id')
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_workshop?idowner=' + idowner + "&idworkshop=" + this.workshop.idworkshop, updatedata, this.requestHeaders)
                    if(response.data.status===true){
                    	this.$toast.success(response.data.msg)
                        this.getdetailworkshopsetprod();
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                    }else{
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async delworkshop(){
                $('#loadingPage').show()
                $('#loadingPage').addClass('overlayLoading');
                try {
                    var idowner = localStorage.getItem('idowner')
                    const delworkshop =new FormData()
                    const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/delete_workshop?idowner=' + idowner + "&idworkshop=" + this.workshop.idworkshop, delworkshop, this.requestHeaders)
                    if(response.data.status===true){
                    	this.$toast.success(response.data.msg)
                        this.back();
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                    }else{
                        $('#loadingPage').hide();
                        $('#loadingPage').removeClass('overlayLoading');
                        this.$toast.error(response.data.msg)
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },

            myChangeEvent(val) {
                this.myValue = val
            },
            mySelectEvent(e) {
                this.workshop.kota = e.text;
                this.workshop.kota_id = e.id;
            },

            async getkotasetprod() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/kota_meta',this.requestHeaders)
                    if (response.status === 200) {
                        var rawkota = response.data.data;
                        this.optionskota.push({id: "", text: "Pilih Kota"})
                        for (var i = 0; i < rawkota.length; i++) {
                            this.optionskota.push({id: rawkota[i].id, text: rawkota[i].nama})
                        }
                    }
                } catch (e) {

                }

            },

            nomorWaOnkeyup() {
                var phoneField = this.telpworkshop;
                var frstCar = phoneField.substring(0, 1);
                var firstTel = phoneField.substring(1, 12);
                var secCar = phoneField.substring(0, 2);
                var secTel = phoneField.substring(2, 12);
                var thrdcar = phoneField.substring(0, 12);
                var output


                if (frstCar == 0) {
                    output = firstTel
                } else if (secCar == this.telpCode) {
                    output = secTel
                } else {
                    output = thrdcar
                }
                var number =output.replace(/[^0-9]+/, '');

                var charLenght = number.length;
                if (charLenght >= 8 && charLenght <= 12) {
                    $('#BtnDetailTelpWorkshop').prop('disabled', false);
                } else {
                    $('#BtnDetailTelpWorkshop').prop('disabled', true);
                }
                this.telpworkshop = number;
            },
        }
    }
</script>

<style scoped>
    .text-detailO{
        border-bottom: 1px solid #EDEDED;
        padding: 12px 20px;

    }

    .nomore {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .hidesection {
        display: none;
    }
</style>